import { Section } from './section';

export class TitleSection extends Section {
  isTitleSection(): boolean {
    return true;
  }
}
